export function getCookie(cname: string) {
  const name = cname + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function setCookie(name: string, value: string, days?: number) {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

export function eraseCookie(name: string, paths: string[]) {
  const expires = new Date(0).toUTCString()
  document.cookie = name + '=; expires=' + expires

  for (let i = 0, l = paths.length; i < l; i++) {
    document.cookie = name + '=; path=' + paths[i] + '; expires=' + expires
  }
}
